export default __webpack_public_path__ + "static/media/LGSmHaTSB.4ac5a4c0.woff2";